import { ModuleContainer } from '../../layout/ModuleContainer.tsx';
import { AppraisifyCommentaryModule } from '../../modules/appraisifyCommentary/AppraisifyCommentaryModule.tsx';

export const AppraisifyCommentaryRouteElement = () => (
  <ModuleContainer moduleID="appraisify-commentary" compact>
    <AppraisifyCommentaryModule />
  </ModuleContainer>
);
